<template>
    <div>
        <config-main-title>
            Validação de Preços para Marcações
        </config-main-title>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                     <div class="col col-12 col-md-6">
                        <az-periodo
                            v-model="filtro"
                            :sync="true"
                            @sync="load()"
                        />
                    </div>
                     <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-filter"
                            :edicao="dados != null"
                            optionsData="id"
                            :optionsList="[
                                { id: '0', search: 'Todos' },
                                { id: '1', search: 'Sem valor' },
                            ]"
                            v-model="filtro.status"
                        />
                    </div>
                     <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-search fa-fw"
                            v-model="filtro.search"
                            :edicao="dados != null"
                        ></az-input>
                     </div>

                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <div id="lista-marcacoes" v-if="dados && lista.length">

             <table class="table table-sm bg-white table-hover small cabecalho-fixo" >
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Paciente</th>
                            <th>Médico</th>
                            <th>Plano/Operadora</th>
                            <th>Unidade</th>
                            <th>Procedimento/Código</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, idx) in lista">
                            <tr :class="item.valor && item.valor.valor <= 0 ?'table-danger' : ''" :key='idx'>
                                <td>{{ $util.getFormatDate(item.marcacao.dt_inicio) }}</td>
                                <td>{{ item.marcacao.nome_paciente }}</td>
                                <td>{{ item.marcacao.medico.search }}</td>
                                <td>
                                    {{ item.marcacao.plano.search }}
                                </td>
                                <td>
                                    <span v-if="item.marcacao.unidade_operacao">
                                        {{ item.marcacao.unidade_operacao.st_sigla }}
                                    </span>
                                </td>
                                <td>
                                    <a href="#" @click.prevent="$util.abrirProcedimento( item.marcacao.procedimento)" class="card-link" v-if="item.marcacao.procedimento">
                                    {{ item.marcacao.procedimento.search }}
                                    </a>
                                    <div class="text-muted" v-if="item.valor && item.valor.item_tabela">
                                    {{ item.valor.item_tabela.st_codigo }}                               
                                    </div>
                                </td>
                                <td>{{ item.valor ? $util.formatMoeda(item.valor.valor) : $util.formatMoeda(0) }}</td>
                            </tr>
                        </template>
                    </tbody>
             </table>

        </div>

         <az-empty-state  v-else/>

    </div>
</template>

<script>
import _ from 'lodash';
// import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzPeriodo from "../../shared/forms/AzPeriodo.vue";
import AzInput from "../../shared/forms/AzInput.vue";

export default {
    data() { 
        return { 
            dados: null, 
            filtro: {
                periodo: "s",
                inicio: "",
                fim: "",

                status: 0,
                search: '',
            }
        }
    },

    components: { 
        // AzSubmit,
        AzEmptyState, 
        ConfigMainTitle,
        AzPeriodo,
        AzInput
    },

    computed: {

          lista: function() {
            if (!this.dados) return [];

            let reg = this.$util.getregex(this.filtro.search);

            return _.orderBy(
                this.dados.filter(item => {
                    return (
                        (!this.filtro.search || reg.test(JSON.stringify(item))) && 
                        (this.filtro.status == 0 || (item.valor && item.valor.valor <= 0))
                    );
                }),
                "marcacao.dt_inicio"
            );
        },

    },

    methods: { 

        load() {

            this.$store.commit("loading", true);

            this.$util.load(this, {
                service: "marcacoes",
                func: "validar_marcacoes",
                parms: {
                    ...this.filtro,
                },
                loadTo: res => {
                    this.dados = res;
                }
            });

        }

    },

    mounted() { 
        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Validação de Preços para Marcações", path: "/config/valid/marcacoes" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.valid_permissao(this, 104);
    }
}
</script>